import React, { useState } from 'react';
import { useSynapse } from 'app/lib/synaptik';
import { Alert, Button, Formbot, Form, Input, Modal, FormGroup, styled } from '@goodrx/matisse';

const ResendButton: any = styled.div`
  color: ${(p) => p.theme.colors.greyDarker};
  text-align: center;
  cursor: pointer;
  margin-top: 1rem;
`;

const ModalBodyText = styled.p`
  margin: 0 0 1rem;
`;

export default function VerifyPhoneModal() {
  const [resendSuccess, setResendSuccess] = useState(false);
  const [
    verifyPhone,
    setShowPhoneVerificationModal,
    showPhoneVerificationModal,
    sendPhoneVerification,
    sendingPhoneVerification,
    sendingPhoneVerificationError,
    verifyingPhone,
  ] = useSynapse(({ user }) => [
    user.verifyPhone,
    user.setShowPhoneVerificationModal,
    user.state.showPhoneVerificationModal,
    user.sendPhoneVerification,
    user.state.sendingPhoneVerification,
    !!user.state.sendingPhoneVerificationError,
    user.state.verifyingPhone,
  ]);

  const handleVerificationSubmit = async ({ values: { code }, isValid }: any) => {
    if (!isValid) return;

    try {
      await verifyPhone(code);
    } catch {}
  };

  async function handleRequestResend() {
    try {
      setResendSuccess(false);
      await sendPhoneVerification();
      setResendSuccess(true);
    } catch {}
  }

  return (
    <Modal
      title="We've sent you a code!"
      maxWidth={500}
      open={showPhoneVerificationModal}
      onClose={() => setShowPhoneVerificationModal(false)}>
      <Modal.Body>
        {resendSuccess && <Alert variant="success">We&apos;ve resent your verification code!</Alert>}
        {sendingPhoneVerificationError && (
          <Alert variant="success">We were unable to send you your verification code. Please try again shortly.</Alert>
        )}
        <ModalBodyText>We require a valid U.S. phone number in order for us to provide you care.</ModalBodyText>
        <Formbot
          validations={{
            code: { required: true },
          }}
          onSubmit={handleVerificationSubmit}>
          <Form>
            <FormGroup>
              <Input type="tel" name="code" maxLength={6} placeholder="Enter your code" autoFocus size="lg" />
            </FormGroup>

            <Button type="submit" size="lg" block loading={verifyingPhone} variant="primary">
              Submit
            </Button>
          </Form>
        </Formbot>

        <ResendButton onClick={handleRequestResend} disabled={sendingPhoneVerification}>
          Resend verification code
        </ResendButton>
      </Modal.Body>
    </Modal>
  );
}
